import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/stake-to-mint-characters-gold.png'


const _withScopeId = n => (_pushScopeId("data-v-41a14636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-to-mint" }
const _hoisted_2 = { class: "stake-to-mint-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stake-to-mint-top parallelogram" }, null, -1))
const _hoisted_4 = { class: "stake-to-mint-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stake-to-mint-bottom parallelogram" }, null, -1))
const _hoisted_6 = { class: "stake-to-mint-subtitle" }
const _hoisted_7 = { class: "stake-to-mint-rank" }
const _hoisted_8 = { class: "stake-to-mint-rank-item-rank" }
const _hoisted_9 = { class: "stake-to-mint-rank-item-title" }
const _hoisted_10 = { class: "stake-to-mint-rank-item-desc" }
const _hoisted_11 = { class: "stake-to-mint-subtitle" }
const _hoisted_12 = { class: "stake-to-mint-action" }
const _hoisted_13 = { class: "stake-to-mint-action-tech" }
const _hoisted_14 = { class: "stake-to-mint-action-tech-title" }
const _hoisted_15 = { class: "stake-to-mint-action-tech-desc" }
const _hoisted_16 = { class: "stake-to-mint-action-tech-desc-first" }
const _hoisted_17 = { class: "stake-to-mint-action-tech-desc-second" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "stake-to-mint-action-button" }
const _hoisted_20 = { class: "stake-to-mint-action-balance" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex mt-1 lg:mt-2" }
const _hoisted_23 = { class: "stake-to-mint-action-input-container" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "input-min-note" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "loading minting"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "stake-to-mint-characters"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stake-to-mint-grass" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('stake_to_mint').toUpperCase()), 1),
      _hoisted_5,
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('higher_rank_better_stats_more_benefits').toUpperCase()), 1),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "stake-to-mint-rank-item nft-main-card"
          }, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(item.rank), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(item.title), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(item.desc), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('rank_2_and_3_fully_minted_and_not_available_for_mint')), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('technicals').toUpperCase()), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "flex lg:mt-2"
                }, [
                  _createVNode(_component_BalIcon, {
                    name: "ci:dot-03-m",
                    size: _ctx.upToLargeBreakpoint ? 'xs' : 'md',
                    class: "stake-to-mint-action-tech-item-icon"
                  }, null, 8, ["size"]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(`technicals_desc${i}`)), 1)
                ])
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "flex lg:mt-2"
                }, [
                  _createVNode(_component_BalIcon, {
                    name: "ci:dot-03-m",
                    size: _ctx.upToLargeBreakpoint ? 'xs' : 'md',
                    class: "stake-to-mint-action-tech-item-icon"
                  }, null, 8, ["size"]),
                  _createElementVNode("p", {
                    innerHTML: 
                    i !== 2
                      ? _ctx.$t(`technicals_desc${i + 3}`)
                      : _ctx.$t(`technicals_desc${i + 3}`, [
                          `<a class='underline' target='_blank' href='https://medium.com/acryptos/nft-gamefi-metaverse-8a75bcf96d1b'>${_ctx.$t(
                            'here'
                          )}</a>`,
                        ])
                  
                  }, null, 8, _hoisted_18)
                ])
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftCols, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t('balance')) + ": ", 1),
                _createElementVNode("span", {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (_ctx.setMax(item))
                }, _toDisplayString(_ctx.balanceShown[item]), 9, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "38",
                      class: "stake-to-mint-action-input",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.stakeMintAmount[item]) = $event)
                    }, null, 8, _hoisted_24), [
                      [_vModelText, _ctx.stakeMintAmount[item]]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", null, "*" + _toDisplayString(_ctx.$t('min')) + " " + _toDisplayString(item === 'acs' ? '8 ACS' : '38 ACSI'), 1),
                    _createElementVNode("span", {
                      class: "cursor-pointer underline",
                      onClick: ($event: any) => (_ctx.openGetAcsiModal(item))
                    }, "(" + _toDisplayString(_ctx.$t('get')) + " " + _toDisplayString(item.toUpperCase()) + " here)", 9, _hoisted_26)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_BalBtn, {
                    rounded: "",
                    color: "red",
                    size: _ctx.upToLargeBreakpoint ? 'xs' : 'md',
                    class: "stake-to-mint-action-button-right",
                    onClick: ($event: any) => (_ctx.stakeMintAction(item))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.stakeMinting[item])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('stake_mint').toUpperCase()), 1))
                    ]),
                    _: 2
                  }, 1032, ["size", "onClick"])
                ])
              ])
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _hoisted_29,
    _hoisted_30
  ]))
}